import { useAuth } from '@clerk/clerk-react';
import React, { useEffect, useState } from 'react';

import BlockingLoader from '~components/commons/blocking-loader/blocking-loader';

const CLERK_LOAD_TIMEOUT_MS = 7000;

interface ClerkWithTimeoutProps {
	children: React.ReactNode;
}

/**
 * Renders children once Clerk has loaded, or after a timeout if Clerk is unavailable.
 * When Clerk times out, the app still renders and relies on the legacy authToken for authentication.
 */
export const ClerkWithTimeout = ({ children }: ClerkWithTimeoutProps) => {
	const { isLoaded } = useAuth();
	const [hasTimedOut, setHasTimedOut] = useState(false);

	useEffect(() => {
		if (!isLoaded) {
			const timer = setTimeout(() => setHasTimedOut(true), CLERK_LOAD_TIMEOUT_MS);
			return () => clearTimeout(timer);
		}
	}, [isLoaded]);

	if (isLoaded || hasTimedOut) {
		return <>{children}</>;
	}

	return <BlockingLoader />;
};
